// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"ShortcutsMenu_wrapperMain__1B_UQ","wrapperInner":"ShortcutsMenu_wrapperInner__1VPrV"};